export const config = {
  // API Configuration
  onboardingBaseUrl: process.env.REACT_APP_ONBOARDING_BASEURL || 'http://localhost:4004',
  
  // Environment
  environment: process.env.REACT_APP_ENV || 'development',
  isDevelopment: process.env.REACT_APP_ENV === 'development',
  isProduction: process.env.REACT_APP_ENV === 'production',
  
  // API Endpoints (using proxy in development)
  api: {
    leads: '/api/leads',
    sendVerificationCode: '/api/leads/send-verification',
    verifyEmail: '/api/leads/verify-email',
    resendVerificationCode: '/api/leads/resend-verification',
    plans: '/api/payments/plans',
    checkout: '/api/payments/checkout',
    paymentConfig: '/api/payments/config',
    validateSubdomain: (subdomain: string) => `/api/organizations/validate-subdomain?subdomain=${encodeURIComponent(subdomain)}`,
    orgSetup: (flowId: string) => `/api/organizations/${flowId}/setup`,
    orgConfigure: (flowId: string) => `/api/organizations/${flowId}/configure`,
    orgDefaults: (flowId: string) => `/api/organizations/${flowId}/defaults`,
    onboardingFlows: '/api/onboarding-flows',
    onboardingFlowById: (flowId: string) => `/api/onboarding-flows/${flowId}`,
    activeFlowByEmail: (email: string) => `/api/onboarding-flows/active-by-email?email=${encodeURIComponent(email)}`,
  },
  
  // URLs
  successUrl: () => `${window.location.origin}/create-organization`,
  cancelUrl: () => `${window.location.origin}/getting-started`,
};

// Log configuration in development
if (config.isDevelopment) {
  console.log('🔧 Environment Configuration:', {
    onboardingBaseUrl: config.onboardingBaseUrl,
    environment: config.environment,
  });
}